import { Dropdown } from '../dropdown';
import Button from './button';
import Item from './item';
import MenuInternal from './menu-internal';
const MenuNamespace = Object.assign(MenuInternal, {
    Button,
    Category: Dropdown.Category,
    Item,
});
export default MenuNamespace;
